import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedSteppers from './CustomizedSteppers';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedSteppers, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/steppers/demos/customized/CustomizedSteppers.tsx",
    "fileName": "CustomizedSteppers.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Stepper from '@mui/material/Stepper';\nimport Step from '@mui/material/Step';\nimport StepLabel from '@mui/material/StepLabel';\nimport Check from '@mui/icons-material/Check';\nimport SettingsIcon from '@mui/icons-material/Settings';\nimport GroupAddIcon from '@mui/icons-material/GroupAdd';\nimport VideoLabelIcon from '@mui/icons-material/VideoLabel';\nimport StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';\nimport type { StepIconProps } from '@mui/material/StepIcon';\n\nconst QontoConnector = styled(StepConnector)(({ theme }) => ({\n  [`&.${stepConnectorClasses.alternativeLabel}`]: {\n    top: 10,\n    left: 'calc(-50% + 16px)',\n    right: 'calc(50% + 16px)',\n  },\n  [`&.${stepConnectorClasses.active}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      borderColor: '#784af4',\n    },\n  },\n  [`&.${stepConnectorClasses.completed}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      borderColor: '#784af4',\n    },\n  },\n  [`& .${stepConnectorClasses.line}`]: {\n    borderColor: '#eaeaf0',\n    borderTopWidth: 3,\n    borderRadius: 1,\n    ...theme.applyStyles('dark', {\n      borderColor: theme.palette.grey[800],\n    }),\n  },\n}));\n\nconst QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(\n  ({ theme }) => ({\n    color: '#eaeaf0',\n    display: 'flex',\n    height: 22,\n    alignItems: 'center',\n    '& .QontoStepIcon-completedIcon': {\n      color: '#784af4',\n      zIndex: 1,\n      fontSize: 18,\n    },\n    '& .QontoStepIcon-circle': {\n      width: 8,\n      height: 8,\n      borderRadius: '50%',\n      backgroundColor: 'currentColor',\n    },\n    ...theme.applyStyles('dark', {\n      color: theme.palette.grey[700],\n    }),\n    variants: [\n      {\n        props: ({ ownerState }) => ownerState.active,\n        style: {\n          color: '#784af4',\n        },\n      },\n    ],\n  }),\n);\n\nfunction QontoStepIcon(props: StepIconProps) {\n  const { active, completed, className } = props;\n\n  return (\n    <QontoStepIconRoot ownerState={{ active }} className={className}>\n      {completed ? (\n        <Check className=\"QontoStepIcon-completedIcon\" />\n      ) : (\n        <div className=\"QontoStepIcon-circle\" />\n      )}\n    </QontoStepIconRoot>\n  );\n}\n\nconst ColorlibConnector = styled(StepConnector)(({ theme }) => ({\n  [`&.${stepConnectorClasses.alternativeLabel}`]: {\n    top: 22,\n  },\n  [`&.${stepConnectorClasses.active}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      backgroundImage:\n        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',\n    },\n  },\n  [`&.${stepConnectorClasses.completed}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      backgroundImage:\n        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',\n    },\n  },\n  [`& .${stepConnectorClasses.line}`]: {\n    height: 3,\n    border: 0,\n    backgroundColor: '#eaeaf0',\n    borderRadius: 1,\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  },\n}));\n\nconst ColorlibStepIconRoot = styled('div')<{\n  ownerState: { completed?: boolean; active?: boolean };\n}>(({ theme }) => ({\n  backgroundColor: '#ccc',\n  zIndex: 1,\n  color: '#fff',\n  width: 50,\n  height: 50,\n  display: 'flex',\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  borderRadius: '50%',\n  justifyContent: 'center',\n  alignItems: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: theme.palette.grey[700],\n  }),\n  variants: [\n    {\n      props: ({ ownerState }) => ownerState.active,\n      style: {\n        backgroundImage:\n          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',\n        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',\n      },\n    },\n    {\n      props: ({ ownerState }) => ownerState.completed,\n      style: {\n        backgroundImage:\n          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',\n      },\n    },\n  ],\n}));\n\nfunction ColorlibStepIcon(props: StepIconProps) {\n  const { active, completed, className } = props;\n\n  const icons: { [index: string]: React.ReactElement<unknown> } = {\n    1: <SettingsIcon />,\n    2: <GroupAddIcon />,\n    3: <VideoLabelIcon />,\n  };\n\n  return (\n    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>\n      {icons[String(props.icon)]}\n    </ColorlibStepIconRoot>\n  );\n}\n\nconst steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];\n\nexport default function CustomizedSteppers() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={4}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stepper alternativeLabel activeStep={1} connector={<QontoConnector />}>\n        {steps.map((label) => (\n          <Step key={label}>\n            <StepLabel slots={{ stepIcon: QontoStepIcon }}>{label}</StepLabel>\n          </Step>\n        ))}\n      </Stepper>\n      <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>\n        {steps.map((label) => (\n          <Step key={label}>\n            <StepLabel slots={{ stepIcon: ColorlibStepIcon }}>{label}</StepLabel>\n          </Step>\n        ))}\n      </Stepper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 183,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport Stepper from '@mui/material/Stepper';\nimport Step from '@mui/material/Step';\nimport StepLabel from '@mui/material/StepLabel';\nimport Check from '@mui/icons-material/Check';\nimport SettingsIcon from '@mui/icons-material/Settings';\nimport GroupAddIcon from '@mui/icons-material/GroupAdd';\nimport VideoLabelIcon from '@mui/icons-material/VideoLabel';\nimport StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';\nimport type { StepIconProps } from '@mui/material/StepIcon';\n\nconst QontoConnector = styled(StepConnector)(({ theme }) => ({\n  [`&.${stepConnectorClasses.alternativeLabel}`]: {\n    top: 10,\n    left: 'calc(-50% + 16px)',\n    right: 'calc(50% + 16px)',\n  },\n  [`&.${stepConnectorClasses.active}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      borderColor: '#784af4',\n    },\n  },\n  [`&.${stepConnectorClasses.completed}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      borderColor: '#784af4',\n    },\n  },\n  [`& .${stepConnectorClasses.line}`]: {\n    borderColor: '#eaeaf0',\n    borderTopWidth: 3,\n    borderRadius: 1,\n    ...theme.applyStyles('dark', {\n      borderColor: theme.palette.grey[800],\n    }),\n  },\n}));\n\nconst QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(\n  ({ theme }) => ({\n    color: '#eaeaf0',\n    display: 'flex',\n    height: 22,\n    alignItems: 'center',\n    '& .QontoStepIcon-completedIcon': {\n      color: '#784af4',\n      zIndex: 1,\n      fontSize: 18,\n    },\n    '& .QontoStepIcon-circle': {\n      width: 8,\n      height: 8,\n      borderRadius: '50%',\n      backgroundColor: 'currentColor',\n    },\n    ...theme.applyStyles('dark', {\n      color: theme.palette.grey[700],\n    }),\n    variants: [\n      {\n        props: ({ ownerState }) => ownerState.active,\n        style: {\n          color: '#784af4',\n        },\n      },\n    ],\n  }),\n);\n\nfunction QontoStepIcon(props: StepIconProps) {\n  const { active, completed, className } = props;\n\n  return (\n    <QontoStepIconRoot ownerState={{ active }} className={className}>\n      {completed ? (\n        <Check className=\"QontoStepIcon-completedIcon\" />\n      ) : (\n        <div className=\"QontoStepIcon-circle\" />\n      )}\n    </QontoStepIconRoot>\n  );\n}\n\nconst ColorlibConnector = styled(StepConnector)(({ theme }) => ({\n  [`&.${stepConnectorClasses.alternativeLabel}`]: {\n    top: 22,\n  },\n  [`&.${stepConnectorClasses.active}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      backgroundImage:\n        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',\n    },\n  },\n  [`&.${stepConnectorClasses.completed}`]: {\n    [`& .${stepConnectorClasses.line}`]: {\n      backgroundImage:\n        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',\n    },\n  },\n  [`& .${stepConnectorClasses.line}`]: {\n    height: 3,\n    border: 0,\n    backgroundColor: '#eaeaf0',\n    borderRadius: 1,\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  },\n}));\n\nconst ColorlibStepIconRoot = styled('div')<{\n  ownerState: { completed?: boolean; active?: boolean };\n}>(({ theme }) => ({\n  backgroundColor: '#ccc',\n  zIndex: 1,\n  color: '#fff',\n  width: 50,\n  height: 50,\n  display: 'flex',\n"
      ],
      [
        "span",
        "frame",
        "  borderRadius: '50%',\n  justifyContent: 'center',\n  alignItems: 'center',\n  ...theme.applyStyles('dark', {\n    backgroundColor: theme.palette.grey[700],\n  }),\n  variants: [\n    {\n      props: ({ ownerState }) => ownerState.active,\n      style: {\n        backgroundImage:\n          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',\n        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',\n      },\n    },\n    {\n      props: ({ ownerState }) => ownerState.completed,\n      style: {\n        backgroundImage:\n          'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',\n      },\n    },\n  ],\n}));\n\nfunction ColorlibStepIcon(props: StepIconProps) {\n  const { active, completed, className } = props;\n\n  const icons: { [index: string]: React.ReactElement<unknown> } = {\n    1: <SettingsIcon />,\n    2: <GroupAddIcon />,\n    3: <VideoLabelIcon />,\n  };\n\n  return (\n    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>\n      {icons[String(props.icon)]}\n    </ColorlibStepIconRoot>\n  );\n}\n\nconst steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];\n\nexport default function CustomizedSteppers() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={4}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Stepper alternativeLabel activeStep={1} connector={<QontoConnector />}>\n        {steps.map((label) => (\n          <Step key={label}>\n            <StepLabel slots={{ stepIcon: QontoStepIcon }}>{label}</StepLabel>\n          </Step>\n        ))}\n      </Stepper>\n      <Stepper alternativeLabel activeStep={1} connector={<ColorlibConnector />}>\n        {steps.map((label) => (\n          <Step key={label}>\n            <StepLabel slots={{ stepIcon: ColorlibStepIcon }}>{label}</StepLabel>\n          </Step>\n        ))}\n      </Stepper>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "2": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 167
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stepper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alternativeLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "activeStep"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "connector"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "QontoConnector"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 168
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "steps"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "label"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 169
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Step"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 170
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "StepLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "slots"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "stepIcon"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "QontoStepIcon"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "StepLabel"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 171
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Step"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 172
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 173
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stepper"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 174
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Stepper"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "alternativeLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "activeStep"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "connector"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "ColorlibConnector"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 175
            },
            [
              "        ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "steps"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "label"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 176
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Step"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 177
            },
            [
              "            <",
              [
                "span",
                "pl-c1 di-jsx",
                "StepLabel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "slots"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "stepIcon"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "ColorlibStepIcon"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "StepLabel"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 178
            },
            [
              "          </",
              [
                "span",
                "pl-c1 di-jsx",
                "Step"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 179
            },
            [
              "        ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 180
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Stepper"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 183,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/Stepper",
      "@mui/material/Step",
      "@mui/material/StepLabel",
      "@mui/icons-material/Check",
      "@mui/icons-material/Settings",
      "@mui/icons-material/GroupAdd",
      "@mui/icons-material/VideoLabel",
      "@mui/material/StepConnector",
      "@mui/material/StepIcon"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
